import GWindow from './GWindow';

class GWindowManager {
  /** @private */
  static count = 0;

  domNode = document.createElement('div');

  /** @private @type {Map<string, GWindow>} */
  gWindows = new Map();

  constructor () {
    this.domNode.id = 'gwndw-mngr';
    this.containerNode = this.domNode.appendChild(
      document.createElement('div')
    );
  }

  destroy () {
    this.closeAllWindows();

    this.domNode.remove();
  }

  closeAllWindows () {
    for (const gwin of this.gWindows.values()) {
      gwin.close();
    }
  }

  /**
   * @param {string} key
   */
  isGWindowKey (key) {
    return this.gWindows.has(key);
  }

  /**
   * @param {string} key
   */
  getGWindow (key) {
    if (!this.isGWindowKey(key)) {
      return null;
    }

    return this.gWindows.get(key);
  }

  /**
   * @param {import('./GWindow').GWindowConfig} param
   */
  createGWindow (param) {
    if (!param.key) {
      param.key = 'Window' + GWindowManager.count++;
    }

    // Always disabling `autoResize` since this is used for mobile view
    const gwin = new GWindow({ ...param, autoResize: false });

    gwin.addCloseCallback(key => this._closeGWinCallback(key));
    this._trackGWin(gwin, param.key);

    return { key: param.key, gWindow: gwin };
  }

  /**
   * @private
   * @param {string} key
   */
  removeGWindow (key) {
    if (!this.isGWindowKey(key)) {
      return null;
    }

    const gwin = this.gWindows.get(key);
    gwin.domNode.remove();

    return gwin;
  }

  /**
   * @param {string} key
   */
  destroyGWindow (key) {
    if (!this.isGWindowKey(key)) {
      return;
    }

    const gwin = this.removeGWindow(key);
    this._untrackGWin(key);
    gwin.destroy();
  }

  /**
   * @private
   * @param {string} key
   */
  _closeGWinCallback (key) {
    this._untrackGWin(key);
  }

  /**
   * @private
   * @param {GWindow} gwin
   * @param {string} key
   */
  _trackGWin (gwin, key) {
    this.gWindows.set(key, gwin);
  }

  /**
   * @private
   * @param {string} key
   */
  _untrackGWin (key) {
    this.gWindows.delete(key);
  }
}

export default GWindowManager;
